import { render, staticRenderFns } from "./EditableCourseWarePage.vue?vue&type=template&id=3a7a528e&scoped=true"
import script from "./EditableCourseWarePage.vue?vue&type=script&lang=ts"
export * from "./EditableCourseWarePage.vue?vue&type=script&lang=ts"
import style0 from "./EditableCourseWarePage.vue?vue&type=style&index=0&id=3a7a528e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a528e",
  null
  
)

export default component.exports